<div class="standard-textbox-container" [class.d-flex]="addOnText">
    @if (addOnText) {
        <span class="input-group-text standard-textbox-add-on" id="add-on-text">{{ addOnText }}</span>
    }

    <div class="w-100">
        @if (replaceTextbox) {
            <ng-content select="[textbox]"></ng-content>
        }

        <input
            #standardTextbox
            type="input"
            [disabled]="disabled"
            class="standard-textbox"
            [placeholder]="label"
            [(ngModel)]="data"
            (ngModelChange)="onChange()"
            (blur)="onTouchedFn()"
            [id]="id"
            [name]="id"
            [class.d-none]="replaceTextbox"
            [class.is-invalid]="control?.invalid"
            aria-describedby="add-on-text"
            [attr.maxlength]="hasBoundFormControl ? null : maxLength"
        />

        <label [for]="id" class="textbox-caption">{{ label }}</label>

        @if (hint?.length) {
            <small class="form-text text-muted d-block mt-1"><i class="far fa-hand-point-right"></i>{{ hint }}</small>
        }

        @if (control?.invalid) {
            <div class="form-text" [ngClass]="{ 'text-danger': validationDisplayType == validationDisplayTypes.StandardValidation, 'invalid-tooltip': validationDisplayType == validationDisplayTypes.StyledValidation }">
                @if (control?.errors?.required) {
                    <div><i class="fas fa-exclamation-circle"></i>{{ 'defaults.validation.nameRequired' | translation: { name: label } | async }}</div>
                }
                @if (control?.errors?.maxlength) {
                    <div><i class="fas fa-exclamation-circle"></i>{{ 'defaults.validation.maxlength' | translation: { name: label, requiredLength: control?.errors?.maxlength.requiredLength } | async }}</div>
                }
                @if (control?.errors?.minlength) {
                    <div><i class="fas fa-exclamation-circle"></i>{{ 'defaults.validation.minlength' | translation: { name: label, requiredLength: control?.errors?.minlength.requiredLength } | async }}</div>
                }
                @if (validationError?.length) {
                    <div><i class="fas fa-exclamation-circle"></i>{{ validationError }}</div>
                }
            </div>
        }
    </div>
</div>
